import { render } from "./AllCompanysView.vue?vue&type=template&id=33ec8310&scoped=true"
import script from "./AllCompanysView.vue?vue&type=script&lang=js"
export * from "./AllCompanysView.vue?vue&type=script&lang=js"

import "./AllCompanysView.vue?vue&type=style&index=0&id=33ec8310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ec8310"]])

export default __exports__